// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-container[data-v-c34f6c2a]{margin:0}.alert-content[data-v-c34f6c2a]{display:flex;gap:20px}.icon-alert[data-v-c34f6c2a]{font-size:20px;padding-top:4px}", ""]);
// Exports
module.exports = exports;
